import { z } from "zod";

export enum BookedAppointmentsReadSource {
  Cobalt = "cobalt",
  SchedulingIndex = "scheduling_index",
  Solv = "solv",
  Webecw = "webecw",
}

export const bookedAppointmentsReadMetadataSchema = z.object({
  source: z.enum(BookedAppointmentsReadSource),
  verifiedWithEhr: z.boolean(),
  canVerifyWithEhr: z.boolean(),
});
export type BookedAppointmentsReadMetadata = z.infer<typeof bookedAppointmentsReadMetadataSchema>;
